import * as React from "react";
const SvgPrimaryDownload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <path
      stroke="#082B60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m13.625 9.562-.808 2.02A3.25 3.25 0 0 1 9.8 13.625H4.45a3.25 3.25 0 0 1-3.017-2.043l-.808-2.02m3.226-2.234 3.25 3.047m0 0 3.25-3.047m-3.25 3.047V.625"
    />
  </svg>
);
export default SvgPrimaryDownload;
